/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { formatProduct } from "./checkoutStarted.js";
export default function productAdded({
  properties
}) {
  return {
    name: "add_to_cart",
    properties: {
      currency: properties.currency || "USD",
      value: properties.price,
      items: [formatProduct(properties)]
    }
  };
}